import React from "react";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import "./StatusChips.css";

export const StatusChips = ({ status, setStatus }) => {

  const statusLabels = [
    {
      id: 1,
      value: "waiting",
      label: "Waiting",
      color: "warning",
    },
    {
      id: 2,
      value: "accepted",
      label: "Accepted",
      color: "success",
    },
    {
      id: 3,
      value: "cancelled",
      label: "Cancelled",
      color: "error",
    },
    {
      id: 4,
      value: "estimated",
      label: "Estimated",
      color: "primary",
    },
    {
      id: 5,
      value: "completed",
      label: "Completed",
      color: "secondary",
    },
  ];



  const handleChipClick = (label) => {
    let updatedStatus;
  
    if (status) {
      const parsedStatus = JSON.parse(status || "[]"); 
      if (!parsedStatus.includes(label)) {
        updatedStatus = [...parsedStatus, label];
      } else {
        updatedStatus = parsedStatus.filter((data) => data !== label);
      }
    } else {
      updatedStatus = [label];
    }
  
    setStatus(JSON.stringify(updatedStatus));
  };
  
 
  
  



  return (
    <div className="chips-container mt-2">
      <Stack direction="row" spacing={1}>
        {statusLabels.map((labels, index) => (
          <Chip
            key={labels.id}
            label={labels.label}
            onClick={() => handleChipClick(labels.label)}
            color={status.includes(labels.label) ? labels.color : "default"}
          />
        ))}
      </Stack>
    </div>
  );
};
